import { Injectable } from '@angular/core';
import { SpinnerService } from 'src/app/shared/services';
import * as blobUtil from 'blob-util';
import { saveAs } from 'file-saver';
import { GET_HEAT_PUMP_INVOICE } from '../queries/energy-credit.queries';
import { Apollo } from 'apollo-angular';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SubmissionConstants } from '../models/constants/submissions-constants';

@Injectable({
  providedIn: 'root',
})
export class HeatPumpInvoiceDownloadService {
  constructor(
    private apolloClient: Apollo,
    private spinnerService: SpinnerService,
    private dialog: DialogService,
  ) {}

  downloadHeatPumpInvoiceDocuments(serialNumber: string): void {
    this.spinnerService.show();
    this.apolloClient
      .query({
        query: GET_HEAT_PUMP_INVOICE,
        variables: { payload: serialNumber },
      })
      .subscribe({
        next: (result: any) => {
          try {
            const items: string[] = result.data.GetHeatPumpInvoice;
            items.forEach((content) => {
              const blob: Blob = blobUtil.base64StringToBlob(content);
              const file = new File([blob], `${serialNumber}.pdf`, {
                type: 'application/pdf',
              });
              saveAs(file);
            });
          } catch {
            this.showOnBaseUnavailableDialog();
          } finally {
            this.spinnerService.hide();
          }
        },
        error: () => {
          this.spinnerService.hide();
          this.showOnBaseUnavailableDialog();
        },
      });
  }

  private showOnBaseUnavailableDialog(): void {
    const constants: SubmissionConstants = new SubmissionConstants();
    this.dialog.openDialog(
      'Unable to Download Invoice',
      `Unable to download invoice from OnBase. Please try again later. If issue persists, contact ${constants.mfgSupportEmail}`,
      'Cancel',
      'OK',
      false,
    );
  }
}
